import { twMerge } from "tailwind-merge";
import type { ISVG } from "./UrlIcon";

export interface RightIconProps extends ISVG {}

export const RightIcon = ({ width, height, className }: RightIconProps) => {
    const _width = width ?? 18;
    const _height = height ?? 12;

    return (
        <svg
            width={_width}
            height={_height}
            viewBox="0 0 18 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={twMerge("fill-black dark:fill-white", className)}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.0896 0.410762C11.7642 0.0853287 11.2365 0.0853287 10.9111 0.410762C10.5857 0.736204 10.5857 1.26384 10.9111 1.58928L14.4885 5.16669H1.50033C1.04009 5.16669 0.666992 5.53977 0.666992 6.00002C0.666992 6.46027 1.04009 6.83335 1.50033 6.83335H14.4885L10.9111 10.4108C10.5857 10.7362 10.5857 11.2639 10.9111 11.5893C11.2365 11.9147 11.7642 11.9147 12.0896 11.5893L17.0896 6.58927C17.415 6.26385 17.415 5.73619 17.0896 5.41077L12.0896 0.410762Z"
            />
        </svg>
    );
};
